module.exports = __webpack_public_path__ + "img/img11.951dd2a3.svg";